<template>
  <div class="aboutmap">
    <div class="aboutexhibit-title-top"></div>
      <div class="aboutexhibit-title-text">
        <h1>{{ $t("contactCenterTitle") }}</h1>
    </div>
    <div class="mapimg" data-aos="zoom-in">
      <router-link to="/contactdetail">
      <img class="left-img" src="@/assets/contactpic/contactCenter.jpg" alt="Map Image">
      </router-link>
      <div class="text">
        <h4>{{ $t("contactCenterText1") }}</h4>
        <span>{{ $t("contactCenterText2") }}</span>
      </div>
    </div>
  </div>
 
</template>

<script>
export default {
  name: "ContactCenter"
}
</script>

<style scoped>
.aboutmap {
  margin-top: 1vw;
  display: grid;
  grid-template-columns: 1fr;
}

.mapimg {
  display: grid;
  grid-template-rows: 1fr .2fr;
  width: 30vw;
  justify-self: center;
  padding-top: 1vw;
}

.left-img {
  width: 100%;
  height: auto;
  align-self: center;
}

.aboutexhibit-title-top {
  height: 5px;
  background-color: #018fd7;
  margin: 0 48vw;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-top: 100px;
}

.aboutexhibit-title-text h1 {
  margin: 0;
}

.text{
  text-align: left;
}

.text h4{
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/contact/contactItem/ContactCenter.vue